import {AWSContent} from "./content/AWSContent";
import {FrameIOContent} from "./content/FrameIOContent";
import {selectConfig} from "../../redux/selectors/firebase";
import {connect} from "react-redux";
import {TabContext, TabList, TabPanel} from "@mui/lab";
import {Box, Tab} from "@mui/material";
import {SoundDashboard} from "./SoundDashboard";
import AssetExplorer from "./AssetExplorer";
import makeStyles from "@mui/styles/makeStyles";
import {SyntheticEvent, useState} from "react";

const useScriptStyles = makeStyles(theme => ({
    tabs: {
        display: 'flex',
        flexDirection: "column",
        flexGrow: 1,
        height: "100%"
    },
    tabPanels: {
        display: "flex",
        flexDirection: "column",
        flexGrow: 1,
        height: "calc(100% - 48px)"
    },
    tabPanel: {
        display: "flex",
        flexDirection: "column",
        flexGrow: 1,
        height: "100%",
        padding: 0
    }
}));

interface ISoundAssets {
    awsContent: AWSContent
    awsRoot?: string
    config: any
    frameIOContent: FrameIOContent
    frameIORoot?: string
}
function SoundAssets({awsContent, awsRoot, config, frameIOContent, frameIORoot}: ISoundAssets) {
    const classes = useScriptStyles();
    const [selected, setSelected] = useState<string>();
    const [tab, setTab] = useState("dashboard");
    const handleAssetClick = (source: string, key: string, format?: string) => {
        setTab(source);
        if (source === "frameIo" && frameIOContent) {
            setSelected(key);
        } else if (source === "aws" && awsContent) {
            setSelected(key);
        }
    };
    const handleTabChange = (event: SyntheticEvent, value: any) => setTab(value);

    return (
        <TabContext value={tab}>
            <Box className={classes.tabs}>
                <TabList onChange={handleTabChange}>
                    <Tab label="Dashboard" value="dashboard"/>
                    <Tab label="Frame.io" value="frameIo"/>
                    <Tab label="AWS" value="aws"/>
                </TabList>
                <Box className={classes.tabPanels}>
                    {tab === "dashboard" &&
                        <TabPanel className={classes.tabPanel} value="dashboard">
                            <SoundDashboard aws={awsContent} config={config} frameIO={frameIOContent}
                                            onClick={handleAssetClick}/>
                        </TabPanel>}
                    {tab === "frameIo" && frameIOContent && frameIORoot &&
                        <TabPanel className={classes.tabPanel} value="frameIo">
                            <AssetExplorer content={frameIOContent} root={frameIORoot} selected={selected}/>
                        </TabPanel>}
                    {tab === "aws" && awsContent && awsRoot &&
                        <TabPanel className={classes.tabPanel} value="aws">
                            <AssetExplorer content={awsContent} root={awsRoot} selected={selected}/>
                        </TabPanel>}
                </Box>
            </Box>
        </TabContext>
    );
}
const mapStateToProps = (store: never) => ({
    config: selectConfig(store)
});
const connected = connect(mapStateToProps, {
})(SoundAssets);

export {connected as SoundAssets};
